*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::-ms-backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box;
  /* 1 */
  border-width: 0;
  /* 2 */
  border-style: solid;
  /* 2 */
  border-color: #e5e7eb;
  /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured `sans` font-family by default.
5. Use the user's configured `sans` font-feature-settings by default.
6. Use the user's configured `sans` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
  -moz-tab-size: 4;
  /* 3 */
  -o-tab-size: 4;
     tab-size: 4;
  /* 3 */
  font-family: BricolageGrotesque, sans-serif;
  /* 4 */
  -webkit-font-feature-settings: normal;
          font-feature-settings: normal;
  /* 5 */
  font-variation-settings: normal;
  /* 6 */
  -webkit-tap-highlight-color: transparent;
  /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.
*/

body {
  margin: 0;
  /* 1 */
  line-height: inherit;
  /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0;
  /* 1 */
  color: inherit;
  /* 2 */
  border-top-width: 1px;
  /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured `mono` font-family by default.
2. Use the user's configured `mono` font-feature-settings by default.
3. Use the user's configured `mono` font-variation-settings by default.
4. Correct the odd `em` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ;
  /* 1 */
  -webkit-font-feature-settings: normal;
          font-feature-settings: normal;
  /* 2 */
  font-variation-settings: normal;
  /* 3 */
  font-size: 1em;
  /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent `sub` and `sup` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0;
  /* 1 */
  border-color: inherit;
  /* 2 */
  border-collapse: collapse;
  /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  -webkit-font-feature-settings: inherit;
          font-feature-settings: inherit;
  /* 1 */
  font-variation-settings: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  font-weight: inherit;
  /* 1 */
  line-height: inherit;
  /* 1 */
  letter-spacing: inherit;
  /* 1 */
  color: inherit;
  /* 1 */
  margin: 0;
  /* 2 */
  padding: 0;
  /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button;
  /* 1 */
  background-color: transparent;
  /* 2 */
  background-image: none;
  /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to `inherit` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

input:-ms-input-placeholder, textarea:-ms-input-placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

input::-ms-input-placeholder, textarea::-ms-input-placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  /* 1 */
  vertical-align: middle;
  /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root {
  --css-interop-darkMode: media;
  --css-interop: true;
  --css-interop-nativewind: true;
}

html,
  body,
  #root {
  height: 100%;
  min-height: 100vh;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-primary)/var(--tw-bg-opacity, 1));
  font-family: BricolageGrotesque, sans-serif;
  --tw-text-opacity: 1;
  color: rgb(var(--color-foreground-primary)/var(--tw-text-opacity, 1));
}

#root {
  display: flex;
  flex-direction: column;
}

a {
  --tw-text-opacity: 1;
  color: rgb(var(--color-markdown-link)/var(--tw-text-opacity, 1));
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

a:hover {
  opacity: 0.8;
}

.container {
  width: 100%;
}

@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}

@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}

@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}

@media (min-width: 1536px) {
  .container {
    max-width: 1536px;
  }
}

.pointer-events-none {
  pointer-events: none;
}

.pointer-events-auto {
  pointer-events: auto;
}

.visible {
  visibility: visible;
}

.invisible {
  visibility: hidden;
}

.collapse {
  visibility: collapse;
}

.static {
  position: static;
}

.fixed {
  position: fixed;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.inset-0 {
  inset: 0px;
}

.inset-x-0 {
  left: 0px;
  right: 0px;
}

.-left-\[9999px\] {
  left: -9999px;
}

.bottom-0 {
  bottom: 0px;
}

.bottom-4 {
  bottom: 8px;
}

.left-0 {
  left: 0px;
}

.left-1\/2 {
  left: 50%;
}

.left-4 {
  left: 8px;
}

.right-0 {
  right: 0px;
}

.right-4 {
  right: 8px;
}

.top-0 {
  top: 0px;
}

.top-10 {
  top: 20px;
}

.top-4 {
  top: 8px;
}

.z-0 {
  z-index: 0;
}

.z-10 {
  z-index: 10;
}

.z-20 {
  z-index: 20;
}

.z-\[1\] {
  z-index: 1;
}

.col-span-1 {
  grid-column: span 1 / span 1;
}

.m-0 {
  margin: 0px;
}

.m-1 {
  margin: 2px;
}

.m-auto {
  margin: auto;
}

.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}

.mx-2 {
  margin-left: 4px;
  margin-right: 4px;
}

.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.my-7 {
  margin-top: 14px;
  margin-bottom: 14px;
}

.mb-1 {
  margin-bottom: 2px;
}

.mb-20 {
  margin-bottom: 40px;
}

.mb-4 {
  margin-bottom: 8px;
}

.mb-40 {
  margin-bottom: 80px;
}

.mb-6 {
  margin-bottom: 12px;
}

.mb-\[0\.1em\] {
  margin-bottom: 0.1em;
}

.ml-8 {
  margin-left: 16px;
}

.mr-8 {
  margin-right: 16px;
}

.mt-1 {
  margin-top: 2px;
}

.mt-2 {
  margin-top: 4px;
}

.mt-20 {
  margin-top: 40px;
}

.mt-4 {
  margin-top: 8px;
}

.mt-8 {
  margin-top: 16px;
}

.mt-\[-16\] {
  margin-top: -16;
}

.box-border {
  box-sizing: border-box;
}

.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.block {
  display: block;
}

.inline-block {
  display: inline-block;
}

.inline {
  display: inline;
}

.flex {
  display: flex;
}

.table {
  display: table;
}

.grid {
  display: grid;
}

.hidden {
  display: none;
}

.h-0 {
  height: 0px;
}

.h-1 {
  height: 2px;
}

.h-1\.5 {
  height: 0.375rem;
}

.h-1\/2 {
  height: 50%;
}

.h-1\/4 {
  height: 25%;
}

.h-10 {
  height: 20px;
}

.h-11 {
  height: 22px;
}

.h-12 {
  height: 24px;
}

.h-120 {
  height: 240px;
}

.h-16 {
  height: 32px;
}

.h-18 {
  height: 36px;
}

.h-2 {
  height: 4px;
}

.h-20 {
  height: 40px;
}

.h-22 {
  height: 44px;
}

.h-24 {
  height: 48px;
}

.h-28 {
  height: 56px;
}

.h-3 {
  height: 6px;
}

.h-3\.5 {
  height: 0.875rem;
}

.h-3\/4 {
  height: 75%;
}

.h-300 {
  height: 600px;
}

.h-32 {
  height: 64px;
}

.h-4 {
  height: 8px;
}

.h-5 {
  height: 10px;
}

.h-6 {
  height: 12px;
}

.h-64 {
  height: 128px;
}

.h-7 {
  height: 14px;
}

.h-8 {
  height: 16px;
}

.h-9 {
  height: 18px;
}

.h-\[0\.6em\] {
  height: 0.6em;
}

.h-\[100px\] {
  height: 100px;
}

.h-\[18px\] {
  height: 18px;
}

.h-\[5px\] {
  height: 5px;
}

.h-\[9px\] {
  height: 9px;
}

.h-auto {
  height: auto;
}

.h-full {
  height: 100%;
}

.h-px {
  height: 1px;
}

.max-h-full {
  max-height: 100%;
}

.min-h-0 {
  min-height: 0px;
}

.min-h-8 {
  min-height: 16px;
}

.min-h-screen {
  min-height: 100vh;
}

.w-1 {
  width: 2px;
}

.w-1\.5 {
  width: 0.375rem;
}

.w-1\/2 {
  width: 50%;
}

.w-1\/4 {
  width: 25%;
}

.w-10 {
  width: 20px;
}

.w-11 {
  width: 22px;
}

.w-12 {
  width: 24px;
}

.w-16 {
  width: 32px;
}

.w-175 {
  width: 350px;
}

.w-18 {
  width: 36px;
}

.w-2 {
  width: 4px;
}

.w-20 {
  width: 40px;
}

.w-24 {
  width: 48px;
}

.w-3 {
  width: 6px;
}

.w-3\.5 {
  width: 0.875rem;
}

.w-3\/4 {
  width: 75%;
}

.w-32 {
  width: 64px;
}

.w-4 {
  width: 8px;
}

.w-5 {
  width: 10px;
}

.w-6 {
  width: 12px;
}

.w-600 {
  width: 1200px;
}

.w-64 {
  width: 128px;
}

.w-7 {
  width: 14px;
}

.w-8 {
  width: 16px;
}

.w-9 {
  width: 18px;
}

.w-\[0\.6em\] {
  width: 0.6em;
}

.w-\[1\.25em\] {
  width: 1.25em;
}

.w-\[18px\] {
  width: 18px;
}

.w-\[5px\] {
  width: 5px;
}

.w-\[60\%\] {
  width: 60%;
}

.w-\[70\%\] {
  width: 70%;
}

.w-\[80\%\] {
  width: 80%;
}

.w-\[800px\] {
  width: 800px;
}

.w-\[90\%\] {
  width: 90%;
}

.w-\[9px\] {
  width: 9px;
}

.w-auto {
  width: auto;
}

.w-full {
  width: 100%;
}

.w-px {
  width: 1px;
}

.min-w-0 {
  min-width: 0px;
}

.min-w-100 {
  min-width: 200px;
}

.min-w-175 {
  min-width: 350px;
}

.min-w-18 {
  min-width: 36px;
}

.min-w-20 {
  min-width: 40px;
}

.min-w-50 {
  min-width: 100px;
}

.min-w-8 {
  min-width: 16px;
}

.min-w-\[200px\] {
  min-width: 200px;
}

.max-w-300 {
  max-width: 600px;
}

.max-w-\[360px\] {
  max-width: 360px;
}

.max-w-\[420px\] {
  max-width: 420px;
}

.max-w-\[510px\] {
  max-width: 510px;
}

.max-w-\[640px\] {
  max-width: 640px;
}

.max-w-full {
  max-width: 100%;
}

.flex-1 {
  flex: 1 1 0%;
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.shrink {
  flex-shrink: 1;
}

.shrink-0 {
  flex-shrink: 0;
}

.flex-grow {
  flex-grow: 1;
}

.grow-0 {
  flex-grow: 0;
}

.caption-bottom {
  caption-side: bottom;
}

.border-collapse {
  border-collapse: collapse;
}

.-translate-x-1\/2 {
  --tw-translate-x: -50%;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-125 {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.transform {
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@-webkit-keyframes pulse {
  50% {
    opacity: .5;
  }
}

@keyframes pulse {
  50% {
    opacity: .5;
  }
}

.animate-pulse {
  -webkit-animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
          animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.cursor-pointer {
  cursor: pointer;
}

.touch-none {
  touch-action: none;
}

.select-none {
  -webkit-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.list-none {
  list-style-type: none;
}

.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}

.flex-row {
  flex-direction: row;
}

.flex-row-reverse {
  flex-direction: row-reverse;
}

.flex-col {
  flex-direction: column;
}

.flex-col-reverse {
  flex-direction: column-reverse;
}

.flex-wrap {
  flex-wrap: wrap;
}

.content-center {
  align-content: center;
}

.items-start {
  align-items: flex-start;
}

.items-end {
  align-items: flex-end;
}

.items-center {
  align-items: center;
}

.items-stretch {
  align-items: stretch;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-around {
  justify-content: space-around;
}

.gap-0 {
  gap: 0px;
}

.gap-0\.5 {
  gap: 0.125rem;
}

.gap-1 {
  gap: 2px;
}

.gap-1\.5 {
  gap: 0.375rem;
}

.gap-10 {
  gap: 20px;
}

.gap-12 {
  gap: 24px;
}

.gap-14 {
  gap: 28px;
}

.gap-16 {
  gap: 32px;
}

.gap-2 {
  gap: 4px;
}

.gap-20 {
  gap: 40px;
}

.gap-24 {
  gap: 48px;
}

.gap-3 {
  gap: 6px;
}

.gap-4 {
  gap: 8px;
}

.gap-5 {
  gap: 10px;
}

.gap-6 {
  gap: 12px;
}

.gap-7 {
  gap: 14px;
}

.gap-8 {
  gap: 16px;
}

.gap-\[inherit\] {
  gap: inherit;
}

.self-start {
  align-self: flex-start;
}

.self-end {
  align-self: flex-end;
}

.self-center {
  align-self: center;
}

.overflow-hidden {
  overflow: hidden;
}

.overflow-visible {
  overflow: visible;
}

.overflow-scroll {
  overflow: scroll;
}

.overflow-x-hidden {
  overflow-x: hidden;
}

.overflow-y-visible {
  overflow-y: visible;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.whitespace-pre-wrap {
  white-space: pre-wrap;
}

.text-wrap {
  text-wrap: wrap;
}

.rounded {
  border-radius: 0.25rem;
}

.rounded-2xl {
  border-radius: 24px;
}

.rounded-\[4px\] {
  border-radius: 4px;
}

.rounded-\[8px\] {
  border-radius: 8px;
}

.rounded-full {
  border-radius: 9999px;
}

.rounded-lg {
  border-radius: 20px;
}

.rounded-md {
  border-radius: 18px;
}

.rounded-none {
  border-radius: 0px;
}

.rounded-sm {
  border-radius: 16px;
}

.rounded-xl {
  border-radius: 22px;
}

.rounded-xs {
  border-radius: 14px;
}

.rounded-b-2xl {
  border-bottom-right-radius: 24px;
  border-bottom-left-radius: 24px;
}

.rounded-r-full {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}

.rounded-t-lg {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.rounded-tl-3xl {
  border-top-left-radius: 28px;
}

.rounded-tr-3xl {
  border-top-right-radius: 28px;
}

.border {
  border-width: 1px;
}

.border-0 {
  border-width: 0px;
}

.border-2 {
  border-width: 2px;
}

.border-4 {
  border-width: 4px;
}

.border-\[1px\] {
  border-width: 1px;
}

.border-\[3px\] {
  border-width: 3px;
}

.border-b {
  border-bottom-width: 1px;
}

.border-b-0 {
  border-bottom-width: 0px;
}

.border-l {
  border-left-width: 1px;
}

.border-r {
  border-right-width: 1px;
}

.border-t {
  border-top-width: 1px;
}

.border-solid {
  border-style: solid;
}

.border-dashed {
  border-style: dashed;
}

.border-background-0 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-background-0)/var(--tw-border-opacity, 1));
}

.border-background-300 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-background-300)/var(--tw-border-opacity, 1));
}

.border-background-tertiary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-background-tertiary)/var(--tw-border-opacity, 1));
}

.border-button-highlighted-border-default {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-button-highlighted-border-default)/var(--tw-border-opacity, 1));
}

.border-button-highlighted-border-disabled {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-button-highlighted-border-disabled)/var(--tw-border-opacity, 1));
}

.border-button-lined-border-default {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-button-lined-border-default)/var(--tw-border-opacity, 1));
}

.border-button-lined-border-disabled {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-button-lined-border-disabled)/var(--tw-border-opacity, 1));
}

.border-error-300 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error-300)/var(--tw-border-opacity, 1));
}

.border-foreground-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-foreground-secondary)/var(--tw-border-opacity, 1));
}

.border-info-300 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-info-300)/var(--tw-border-opacity, 1));
}

.border-information-negative {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-information-negative)/var(--tw-border-opacity, 1));
}

.border-information-neutral {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-information-neutral)/var(--tw-border-opacity, 1));
}

.border-lining-medium {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-lining-medium)/var(--tw-border-opacity, 1));
}

.border-outline-100 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-outline-100)/var(--tw-border-opacity, 1));
}

.border-outline-200 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-outline-200)/var(--tw-border-opacity, 1));
}

.border-outline-400 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-outline-400)/var(--tw-border-opacity, 1));
}

.border-primary-300 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary-300)/var(--tw-border-opacity, 1));
}

.border-primary-500 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary-500)/var(--tw-border-opacity, 1));
}

.border-secondary-300 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary-300)/var(--tw-border-opacity, 1));
}

.border-success-300 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success-300)/var(--tw-border-opacity, 1));
}

.border-warning-300 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning-300)/var(--tw-border-opacity, 1));
}

.bg-background-0 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-0)/var(--tw-bg-opacity, 1));
}

.bg-background-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-200)/var(--tw-bg-opacity, 1));
}

.bg-background-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-300)/var(--tw-bg-opacity, 1));
}

.bg-background-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-400)/var(--tw-bg-opacity, 1));
}

.bg-background-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-50)/var(--tw-bg-opacity, 1));
}

.bg-background-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-800)/var(--tw-bg-opacity, 1));
}

.bg-background-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-900)/var(--tw-bg-opacity, 1));
}

.bg-background-contrast\/30 {
  background-color: rgb(var(--color-background-contrast)/0.3);
}

.bg-background-dark {
  --tw-bg-opacity: 1;
  background-color: rgb(24 23 25 / var(--tw-bg-opacity, 1));
}

.bg-background-error {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-error)/var(--tw-bg-opacity, 1));
}

.bg-background-info {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-info)/var(--tw-bg-opacity, 1));
}

.bg-background-muted {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-muted)/var(--tw-bg-opacity, 1));
}

.bg-background-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-primary)/var(--tw-bg-opacity, 1));
}

.bg-background-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-secondary)/var(--tw-bg-opacity, 1));
}

.bg-background-success {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-success)/var(--tw-bg-opacity, 1));
}

.bg-background-tertiary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-tertiary)/var(--tw-bg-opacity, 1));
}

.bg-background-warning {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-warning)/var(--tw-bg-opacity, 1));
}

.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}

.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}

.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}

.bg-button-advisor-surface-default {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-advisor-surface-default)/var(--tw-bg-opacity, 1));
}

.bg-button-advisor-surface-disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-advisor-surface-disabled)/var(--tw-bg-opacity, 1));
}

.bg-button-highlighted-surface-default {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-highlighted-surface-default)/var(--tw-bg-opacity, 1));
}

.bg-button-highlighted-surface-disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-highlighted-surface-disabled)/var(--tw-bg-opacity, 1));
}

.bg-button-lined-surface-default {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-lined-surface-default)/var(--tw-bg-opacity, 1));
}

.bg-button-lined-surface-disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-lined-surface-disabled)/var(--tw-bg-opacity, 1));
}

.bg-button-primary-surface-default {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-primary-surface-default)/var(--tw-bg-opacity, 1));
}

.bg-button-primary-surface-disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-primary-surface-disabled)/var(--tw-bg-opacity, 1));
}

.bg-button-secondary-surface-default {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-secondary-surface-default)/var(--tw-bg-opacity, 1));
}

.bg-button-secondary-surface-disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-secondary-surface-disabled)/var(--tw-bg-opacity, 1));
}

.bg-error-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-error-500)/var(--tw-bg-opacity, 1));
}

.bg-error-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-error-800)/var(--tw-bg-opacity, 1));
}

.bg-foreground-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-foreground-primary)/var(--tw-bg-opacity, 1));
}

.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}

.bg-info-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-info-700)/var(--tw-bg-opacity, 1));
}

.bg-primary-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary-500)/var(--tw-bg-opacity, 1));
}

.bg-primary-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary-600)/var(--tw-bg-opacity, 1));
}

.bg-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}

.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}

.bg-red-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}

.bg-secondary-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-secondary-500)/var(--tw-bg-opacity, 1));
}

.bg-success-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success-500)/var(--tw-bg-opacity, 1));
}

.bg-success-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success-700)/var(--tw-bg-opacity, 1));
}

.bg-transparent {
  background-color: rgba(0,0,0,0);
}

.bg-warning-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-warning-700)/var(--tw-bg-opacity, 1));
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}

.fill-none {
  fill: none;
}

.fill-primary-800 {
  fill: rgb(var(--color-primary-800)/1);
}

.p-0 {
  padding: 0px;
}

.p-1 {
  padding: 2px;
}

.p-10 {
  padding: 20px;
}

.p-2 {
  padding: 4px;
}

.p-3 {
  padding: 6px;
}

.p-3\.5 {
  padding: 0.875rem;
}

.p-4 {
  padding: 8px;
}

.p-5 {
  padding: 10px;
}

.p-6 {
  padding: 12px;
}

.p-\[18px\] {
  padding: 18px;
}

.p-\[2px\] {
  padding: 2px;
}

.p-\[3px\] {
  padding: 3px;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.px-10 {
  padding-left: 20px;
  padding-right: 20px;
}

.px-12 {
  padding-left: 24px;
  padding-right: 24px;
}

.px-14 {
  padding-left: 28px;
  padding-right: 28px;
}

.px-2 {
  padding-left: 4px;
  padding-right: 4px;
}

.px-2\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}

.px-20 {
  padding-left: 40px;
  padding-right: 40px;
}

.px-3 {
  padding-left: 6px;
  padding-right: 6px;
}

.px-4 {
  padding-left: 8px;
  padding-right: 8px;
}

.px-5 {
  padding-left: 10px;
  padding-right: 10px;
}

.px-6 {
  padding-left: 12px;
  padding-right: 12px;
}

.px-7 {
  padding-left: 14px;
  padding-right: 14px;
}

.px-8 {
  padding-left: 16px;
  padding-right: 16px;
}

.px-\[7px\] {
  padding-left: 7px;
  padding-right: 7px;
}

.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.py-1 {
  padding-top: 2px;
  padding-bottom: 2px;
}

.py-12 {
  padding-top: 24px;
  padding-bottom: 24px;
}

.py-2 {
  padding-top: 4px;
  padding-bottom: 4px;
}

.py-2\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}

.py-3 {
  padding-top: 6px;
  padding-bottom: 6px;
}

.py-4 {
  padding-top: 8px;
  padding-bottom: 8px;
}

.py-5 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.py-6 {
  padding-top: 12px;
  padding-bottom: 12px;
}

.py-\[14px\] {
  padding-top: 14px;
  padding-bottom: 14px;
}

.py-\[7px\] {
  padding-top: 7px;
  padding-bottom: 7px;
}

.pb-10 {
  padding-bottom: 20px;
}

.pb-3 {
  padding-bottom: 6px;
}

.pr-2 {
  padding-right: 4px;
}

.pr-4 {
  padding-right: 8px;
}

.pt-1 {
  padding-top: 2px;
}

.pt-10 {
  padding-top: 20px;
}

.pt-2 {
  padding-top: 4px;
}

.pt-\[20\%\] {
  padding-top: 20%;
}

.pt-\[24\] {
  padding-top: 24;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-start {
  text-align: start;
}

.align-middle {
  vertical-align: middle;
}

.font-bricolage {
  font-family: BricolageGrotesque, sans-serif;
}

.font-sans {
  font-family: BricolageGrotesque, sans-serif;
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}

.text-5xl {
  font-size: 3rem;
  line-height: 1;
}

.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}

.text-\[16px\] {
  font-size: 16px;
}

.text-\[32px\] {
  font-size: 32px;
}

.text-\[length\:inherit\] {
  font-size: inherit;
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}

.font-bold {
  font-weight: 700;
}

.font-medium {
  font-weight: 500;
}

.font-normal {
  font-weight: 400;
}

.font-semibold {
  font-weight: 600;
}

.uppercase {
  text-transform: uppercase;
}

.italic {
  font-style: italic;
}

.ordinal {
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}

.\!leading-\[100\%\] {
  line-height: 100% !important;
}

.leading-5 {
  line-height: 1.25rem;
}

.leading-\[22px\] {
  line-height: 22px;
}

.leading-\[inherit\] {
  line-height: inherit;
}

.leading-none {
  line-height: 1;
}

.tracking-normal {
  letter-spacing: 0em;
}

.tracking-tight {
  letter-spacing: -0.025em;
}

.text-\[\#ff0000\] {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity, 1));
}

.text-background-500 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-background-500)/var(--tw-text-opacity, 1));
}

.text-background-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-background-800)/var(--tw-text-opacity, 1));
}

.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}

.text-button-advisor-icon-default {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-advisor-icon-default)/var(--tw-text-opacity, 1));
}

.text-button-advisor-icon-disabled {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-advisor-icon-disabled)/var(--tw-text-opacity, 1));
}

.text-button-advisor-label-default {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-advisor-label-default)/var(--tw-text-opacity, 1));
}

.text-button-advisor-label-disabled {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-advisor-label-disabled)/var(--tw-text-opacity, 1));
}

.text-button-highlighted-label-default {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-highlighted-label-default)/var(--tw-text-opacity, 1));
}

.text-button-highlighted-label-disabled {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-highlighted-label-disabled)/var(--tw-text-opacity, 1));
}

.text-button-lined-label-default {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-lined-label-default)/var(--tw-text-opacity, 1));
}

.text-button-lined-label-disabled {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-lined-label-disabled)/var(--tw-text-opacity, 1));
}

.text-button-primary-label-default {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-primary-label-default)/var(--tw-text-opacity, 1));
}

.text-button-primary-label-disabled {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-primary-label-disabled)/var(--tw-text-opacity, 1));
}

.text-button-secondary-label-default {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-secondary-label-default)/var(--tw-text-opacity, 1));
}

.text-button-secondary-label-disabled {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-secondary-label-disabled)/var(--tw-text-opacity, 1));
}

.text-button-text-label-default {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-text-label-default)/var(--tw-text-opacity, 1));
}

.text-button-text-label-disabled {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-text-label-disabled)/var(--tw-text-opacity, 1));
}

.text-error-600 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-error-600)/var(--tw-text-opacity, 1));
}

.text-error-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-error-700)/var(--tw-text-opacity, 1));
}

.text-error-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-error-800)/var(--tw-text-opacity, 1));
}

.text-foreground-contrast {
  --tw-text-opacity: 1;
  color: rgb(var(--color-foreground-contrast)/var(--tw-text-opacity, 1));
}

.text-foreground-primary {
  --tw-text-opacity: 1;
  color: rgb(var(--color-foreground-primary)/var(--tw-text-opacity, 1));
}

.text-foreground-primary\/80 {
  color: rgb(var(--color-foreground-primary)/0.8);
}

.text-foreground-secondary {
  --tw-text-opacity: 1;
  color: rgb(var(--color-foreground-secondary)/var(--tw-text-opacity, 1));
}

.text-foreground-tertiary {
  --tw-text-opacity: 1;
  color: rgb(var(--color-foreground-tertiary)/var(--tw-text-opacity, 1));
}

.text-grade-bad {
  --tw-text-opacity: 1;
  color: rgb(var(--color-grade-bad)/var(--tw-text-opacity, 1));
}

.text-grade-good {
  --tw-text-opacity: 1;
  color: rgb(var(--color-grade-good)/var(--tw-text-opacity, 1));
}

.text-grade-weak {
  --tw-text-opacity: 1;
  color: rgb(var(--color-grade-weak)/var(--tw-text-opacity, 1));
}

.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}

.text-info-600 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-info-600)/var(--tw-text-opacity, 1));
}

.text-info-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-info-700)/var(--tw-text-opacity, 1));
}

.text-info-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-info-800)/var(--tw-text-opacity, 1));
}

.text-information-negative {
  --tw-text-opacity: 1;
  color: rgb(var(--color-information-negative)/var(--tw-text-opacity, 1));
}

.text-information-neutral {
  --tw-text-opacity: 1;
  color: rgb(var(--color-information-neutral)/var(--tw-text-opacity, 1));
}

.text-information-positive {
  --tw-text-opacity: 1;
  color: rgb(var(--color-information-positive)/var(--tw-text-opacity, 1));
}

.text-inherit {
  color: inherit;
}

.text-markdown-link {
  --tw-text-opacity: 1;
  color: rgb(var(--color-markdown-link)/var(--tw-text-opacity, 1));
}

.text-primary-500 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary-500)/var(--tw-text-opacity, 1));
}

.text-primary-600 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary-600)/var(--tw-text-opacity, 1));
}

.text-primary-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary-800)/var(--tw-text-opacity, 1));
}

.text-red-900 {
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}

.text-success-600 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-success-600)/var(--tw-text-opacity, 1));
}

.text-success-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-success-800)/var(--tw-text-opacity, 1));
}

.text-transparent {
  color: rgba(0,0,0,0);
}

.text-typography-0 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-0)/var(--tw-text-opacity, 1));
}

.text-typography-400 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-400)/var(--tw-text-opacity, 1));
}

.text-typography-50 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-50)/var(--tw-text-opacity, 1));
}

.text-typography-500 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-500)/var(--tw-text-opacity, 1));
}

.text-typography-600 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-600)/var(--tw-text-opacity, 1));
}

.text-typography-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-700)/var(--tw-text-opacity, 1));
}

.text-typography-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-800)/var(--tw-text-opacity, 1));
}

.text-typography-900 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-900)/var(--tw-text-opacity, 1));
}

.text-typography-950 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-950)/var(--tw-text-opacity, 1));
}

.text-warning-600 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-warning-600)/var(--tw-text-opacity, 1));
}

.text-warning-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-warning-800)/var(--tw-text-opacity, 1));
}

.text-opacity-80 {
  --tw-text-opacity: 0.8;
}

.underline {
  text-decoration-line: underline;
}

.line-through {
  text-decoration-line: line-through;
}

.no-underline {
  text-decoration-line: none;
}

.caret-foreground-primary {
  caret-color: rgb(var(--color-foreground-primary)/1);
}

.opacity-0 {
  opacity: 0;
}

.opacity-50 {
  opacity: 0.5;
}

.shadow-hard-1 {
  --tw-shadow: -2px 2px 8px 0px rgba(38, 38, 38, 0.20);
  --tw-shadow-colored: -2px 2px 8px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-hard-2 {
  --tw-shadow: 0px 3px 10px 0px rgba(38, 38, 38, 0.20);
  --tw-shadow-colored: 0px 3px 10px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-hard-5 {
  --tw-shadow: 0px 2px 10px 0px rgba(38, 38, 38, 0.10);
  --tw-shadow-colored: 0px 2px 10px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-soft-3 {
  --tw-shadow: 0px 0px 30px rgba(38, 38, 38, 0.1);
  --tw-shadow-colored: 0px 0px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.outline {
  outline-style: solid;
}

.outline-0 {
  outline-width: 0px;
}

.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.ring-background-primary {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--color-background-primary)/var(--tw-ring-opacity, 1));
}

.blur {
  --tw-blur: blur(8px);
  -webkit-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
          filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.invert {
  --tw-invert: invert(100%);
  -webkit-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
          filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.filter {
  -webkit-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
          filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, backdrop-filter, -webkit-transform, -webkit-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-transform, -webkit-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.duration-100 {
  transition-duration: 100ms;
}

.duration-150 {
  transition-duration: 150ms;
}

.duration-200 {
  transition-duration: 200ms;
}

.duration-75 {
  transition-duration: 75ms;
}

.color-typography-900 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-900)/var(--tw-text-opacity, 1));
}

.graph-edge-mask {
  -webkit-mask-image: linear-gradient(
      to right,
      transparent 0%,
      rgb(0 0 0 / 0.05) 8%,
      rgb(0 0 0 / 0.2) 18%,
      #000 33%,
      #000 67%,
      rgb(0 0 0 / 0.2) 82%,
      rgb(0 0 0 / 0.05) 92%,
      transparent 100%
    );
  mask-image: linear-gradient(
      to right,
      transparent 0%,
      rgb(0 0 0 / 0.05) 8%,
      rgb(0 0 0 / 0.2) 18%,
      #000 33%,
      #000 67%,
      rgb(0 0 0 / 0.2) 82%,
      rgb(0 0 0 / 0.05) 92%,
      transparent 100%
    );
}

.\[-webkit-text-fill-color\:transparent\] {
  -webkit-text-fill-color: transparent;
}

.selection\:bg-foreground-primary\/15 *::selection {
  background-color: rgb(var(--color-foreground-primary)/0.15);
}

.selection\:text-transparent *::selection {
  color: rgba(0,0,0,0);
}

.selection\:bg-foreground-primary\/15::selection {
  background-color: rgb(var(--color-foreground-primary)/0.15);
}

.selection\:text-transparent::selection {
  color: rgba(0,0,0,0);
}

.placeholder\:text-transparent::-webkit-input-placeholder {
  color: rgba(0,0,0,0);
}

.placeholder\:text-transparent:-ms-input-placeholder {
  color: rgba(0,0,0,0);
}

.placeholder\:text-transparent::-ms-input-placeholder {
  color: rgba(0,0,0,0);
}

.placeholder\:text-transparent::placeholder {
  color: rgba(0,0,0,0);
}

.placeholder\:text-typography-500::-webkit-input-placeholder {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-500)/var(--tw-text-opacity, 1));
}

.placeholder\:text-typography-500:-ms-input-placeholder {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-500)/var(--tw-text-opacity, 1));
}

.placeholder\:text-typography-500::-ms-input-placeholder {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-500)/var(--tw-text-opacity, 1));
}

.placeholder\:text-typography-500::placeholder {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-500)/var(--tw-text-opacity, 1));
}

.focus-within\:border-lining-focused:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-lining-focused)/var(--tw-border-opacity, 1));
}

.hover\:bg-background-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-50)/var(--tw-bg-opacity, 1));
}

.hover\:bg-primary-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary-600)/var(--tw-bg-opacity, 1));
}

.hover\:bg-zinc-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / var(--tw-bg-opacity, 1));
}

.hover\:bg-zinc-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}

.focus\:bg-background-100:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-100)/var(--tw-bg-opacity, 1));
}

.focus\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.active\:\!border-button-highlighted-border-pressed:active {
  --tw-border-opacity: 1 !important;
  border-color: rgb(var(--color-button-highlighted-border-pressed)/var(--tw-border-opacity, 1)) !important;
}

.active\:\!border-button-lined-border-pressed:active {
  --tw-border-opacity: 1 !important;
  border-color: rgb(var(--color-button-lined-border-pressed)/var(--tw-border-opacity, 1)) !important;
}

.active\:\!bg-button-advisor-surface-pressed:active {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--color-button-advisor-surface-pressed)/var(--tw-bg-opacity, 1)) !important;
}

.active\:\!bg-button-highlighted-surface-pressed:active {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--color-button-highlighted-surface-pressed)/var(--tw-bg-opacity, 1)) !important;
}

.active\:\!bg-button-lined-surface-pressed:active {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--color-button-lined-surface-pressed)/var(--tw-bg-opacity, 1)) !important;
}

.active\:\!bg-button-primary-surface-pressed:active {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--color-button-primary-surface-pressed)/var(--tw-bg-opacity, 1)) !important;
}

.active\:\!bg-button-secondary-surface-pressed:active {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--color-button-secondary-surface-pressed)/var(--tw-bg-opacity, 1)) !important;
}

.active\:bg-background-100:active {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-100)/var(--tw-bg-opacity, 1));
}

.active\:bg-primary-700:active {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary-700)/var(--tw-bg-opacity, 1));
}

.active\:\!text-button-advisor-icon-pressed:active {
  --tw-text-opacity: 1 !important;
  color: rgb(var(--color-button-advisor-icon-pressed)/var(--tw-text-opacity, 1)) !important;
}

.active\:\!text-button-advisor-label-pressed:active {
  --tw-text-opacity: 1 !important;
  color: rgb(var(--color-button-advisor-label-pressed)/var(--tw-text-opacity, 1)) !important;
}

.active\:\!text-button-highlighted-label-pressed:active {
  --tw-text-opacity: 1 !important;
  color: rgb(var(--color-button-highlighted-label-pressed)/var(--tw-text-opacity, 1)) !important;
}

.active\:\!text-button-lined-label-pressed:active {
  --tw-text-opacity: 1 !important;
  color: rgb(var(--color-button-lined-label-pressed)/var(--tw-text-opacity, 1)) !important;
}

.active\:\!text-button-primary-label-pressed:active {
  --tw-text-opacity: 1 !important;
  color: rgb(var(--color-button-primary-label-pressed)/var(--tw-text-opacity, 1)) !important;
}

.active\:\!text-button-secondary-label-pressed:active {
  --tw-text-opacity: 1 !important;
  color: rgb(var(--color-button-secondary-label-pressed)/var(--tw-text-opacity, 1)) !important;
}

.active\:\!text-button-text-label-pressed:active {
  --tw-text-opacity: 1 !important;
  color: rgb(var(--color-button-text-label-pressed)/var(--tw-text-opacity, 1)) !important;
}

.disabled\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\:opacity-40:disabled {
  opacity: 0.4;
}

.group\/button:active .group-active\/button\:text-button-advisor-icon-pressed {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-advisor-icon-pressed)/var(--tw-text-opacity, 1));
}

.group\/button:active .group-active\/button\:text-button-advisor-label-pressed {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-advisor-label-pressed)/var(--tw-text-opacity, 1));
}

.group\/button:active .group-active\/button\:text-button-highlighted-label-pressed {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-highlighted-label-pressed)/var(--tw-text-opacity, 1));
}

.group\/button:active .group-active\/button\:text-button-lined-label-pressed {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-lined-label-pressed)/var(--tw-text-opacity, 1));
}

.group\/button:active .group-active\/button\:text-button-primary-label-pressed {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-primary-label-pressed)/var(--tw-text-opacity, 1));
}

.group\/button:active .group-active\/button\:text-button-secondary-label-pressed {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-secondary-label-pressed)/var(--tw-text-opacity, 1));
}

.group\/button:active .group-active\/button\:text-button-text-label-pressed {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-text-label-pressed)/var(--tw-text-opacity, 1));
}

.group\/avatar-group.avatar-group .group-\[\.avatar-group\]\/avatar-group\:-ml-2\.5 {
  margin-left: -0.625rem;
}

.data-\[disabled\=true\]\:cursor-not-allowed[data-disabled="true"] {
  cursor: not-allowed;
}

.data-\[invalid\=true\]\:rounded-xl[data-invalid="true"] {
  border-radius: 22px;
}

.data-\[focus-visible\=true\]\:border-0[data-focus-visible="true"] {
  border-width: 0px;
}

.data-\[focus\=true\]\:border-0[data-focus="true"] {
  border-width: 0px;
}

.data-\[hover\=true\]\:border-0[data-hover="true"] {
  border-width: 0px;
}

.data-\[invalid\=true\]\:border-0[data-invalid="true"] {
  border-width: 0px;
}

.data-\[invalid\=true\]\:border-2[data-invalid="true"] {
  border-width: 2px;
}

.data-\[invalid\=true\]\:data-\[focus\=true\]\:border-0[data-focus="true"][data-invalid="true"] {
  border-width: 0px;
}

.data-\[invalid\=true\]\:data-\[hover\=true\]\:border-0[data-hover="true"][data-invalid="true"] {
  border-width: 0px;
}

.data-\[flip\=false\]\:border-b-0[data-flip="false"] {
  border-bottom-width: 0px;
}

.data-\[flip\=false\]\:border-l-0[data-flip="false"] {
  border-left-width: 0px;
}

.data-\[flip\=false\]\:border-r-0[data-flip="false"] {
  border-right-width: 0px;
}

.data-\[flip\=false\]\:border-t-0[data-flip="false"] {
  border-top-width: 0px;
}

.data-\[flip\=true\]\:border-b-0[data-flip="true"] {
  border-bottom-width: 0px;
}

.data-\[flip\=true\]\:border-l-0[data-flip="true"] {
  border-left-width: 0px;
}

.data-\[flip\=true\]\:border-r-0[data-flip="true"] {
  border-right-width: 0px;
}

.data-\[flip\=true\]\:border-t-0[data-flip="true"] {
  border-top-width: 0px;
}

.data-\[invalid\=true\]\:border-b-2[data-invalid="true"] {
  border-bottom-width: 2px;
}

.data-\[active\=true\]\:border-button-highlighted-border-pressed[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-button-highlighted-border-pressed)/var(--tw-border-opacity, 1));
}

.data-\[active\=true\]\:border-button-lined-border-pressed[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-button-lined-border-pressed)/var(--tw-border-opacity, 1));
}

.data-\[active\=true\]\:border-error-500[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error-500)/var(--tw-border-opacity, 1));
}

.data-\[active\=true\]\:border-primary-500[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary-500)/var(--tw-border-opacity, 1));
}

.data-\[active\=true\]\:border-primary-800[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary-800)/var(--tw-border-opacity, 1));
}

.data-\[active\=true\]\:border-secondary-700[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary-700)/var(--tw-border-opacity, 1));
}

.data-\[active\=true\]\:border-success-500[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success-500)/var(--tw-border-opacity, 1));
}

.data-\[active\=true\]\:data-\[checked\=true\]\:border-primary-800[data-checked="true"][data-active="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary-800)/var(--tw-border-opacity, 1));
}

.data-\[checked\=true\]\:border-primary-600[data-checked="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary-600)/var(--tw-border-opacity, 1));
}

.data-\[disabled\=true\]\:data-\[checked\=true\]\:border-outline-400[data-checked="true"][data-disabled="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-outline-400)/var(--tw-border-opacity, 1));
}

.data-\[disabled\=true\]\:data-\[hover\=true\]\:border-background-300[data-hover="true"][data-disabled="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-background-300)/var(--tw-border-opacity, 1));
}

.data-\[disabled\=true\]\:data-\[invalid\=true\]\:border-error-400[data-invalid="true"][data-disabled="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error-400)/var(--tw-border-opacity, 1));
}

.data-\[focus\=true\]\:border-primary-700[data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary-700)/var(--tw-border-opacity, 1));
}

.data-\[focus\=true\]\:data-\[hover\=true\]\:border-primary-700[data-hover="true"][data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary-700)/var(--tw-border-opacity, 1));
}

.data-\[hover\=true\]\:border-button-highlighted-border-hover[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-button-highlighted-border-hover)/var(--tw-border-opacity, 1));
}

.data-\[hover\=true\]\:border-button-lined-border-hover[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-button-lined-border-hover)/var(--tw-border-opacity, 1));
}

.data-\[hover\=true\]\:border-error-400[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error-400)/var(--tw-border-opacity, 1));
}

.data-\[hover\=true\]\:border-outline-400[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-outline-400)/var(--tw-border-opacity, 1));
}

.data-\[hover\=true\]\:border-outline-500[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-outline-500)/var(--tw-border-opacity, 1));
}

.data-\[hover\=true\]\:border-primary-400[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary-400)/var(--tw-border-opacity, 1));
}

.data-\[hover\=true\]\:border-primary-700[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary-700)/var(--tw-border-opacity, 1));
}

.data-\[hover\=true\]\:border-secondary-400[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary-400)/var(--tw-border-opacity, 1));
}

.data-\[hover\=true\]\:border-success-400[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success-400)/var(--tw-border-opacity, 1));
}

.data-\[hover\=true\]\:data-\[checked\=false\]\:border-outline-500[data-checked="false"][data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-outline-500)/var(--tw-border-opacity, 1));
}

.data-\[hover\=true\]\:data-\[checked\=true\]\:border-primary-700[data-checked="true"][data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary-700)/var(--tw-border-opacity, 1));
}

.data-\[hover\=true\]\:data-\[checked\=true\]\:data-\[disabled\=true\]\:border-primary-600[data-disabled="true"][data-checked="true"][data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary-600)/var(--tw-border-opacity, 1));
}

.data-\[hover\=true\]\:data-\[checked\=true\]\:data-\[disabled\=true\]\:data-\[invalid\=true\]\:border-error-700[data-invalid="true"][data-disabled="true"][data-checked="true"][data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error-700)/var(--tw-border-opacity, 1));
}

.data-\[hover\=true\]\:data-\[disabled\=true\]\:border-outline-400[data-disabled="true"][data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-outline-400)/var(--tw-border-opacity, 1));
}

.data-\[hover\=true\]\:data-\[disabled\=true\]\:data-\[invalid\=true\]\:border-error-400[data-invalid="true"][data-disabled="true"][data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error-400)/var(--tw-border-opacity, 1));
}

.data-\[hover\=true\]\:data-\[disabled\=true\]\:data-\[invalid\=true\]\:border-error-700[data-invalid="true"][data-disabled="true"][data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error-700)/var(--tw-border-opacity, 1));
}

.data-\[hover\=true\]\:data-\[invalid\=true\]\:border-error-700[data-invalid="true"][data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error-700)/var(--tw-border-opacity, 1));
}

.data-\[invalid\=true\]\:border-error-700[data-invalid="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error-700)/var(--tw-border-opacity, 1));
}

.data-\[invalid\=true\]\:data-\[disabled\=true\]\:data-\[hover\=true\]\:border-error-700[data-hover="true"][data-disabled="true"][data-invalid="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error-700)/var(--tw-border-opacity, 1));
}

.data-\[invalid\=true\]\:data-\[focus\=true\]\:border-error-700[data-focus="true"][data-invalid="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error-700)/var(--tw-border-opacity, 1));
}

.data-\[invalid\=true\]\:data-\[focus\=true\]\:data-\[hover\=true\]\:border-primary-700[data-hover="true"][data-focus="true"][data-invalid="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary-700)/var(--tw-border-opacity, 1));
}

.data-\[invalid\=true\]\:data-\[hover\=true\]\:border-error-700[data-hover="true"][data-invalid="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error-700)/var(--tw-border-opacity, 1));
}

.data-\[active\=true\]\:\!bg-background-tertiary[data-active="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--color-background-tertiary)/var(--tw-bg-opacity, 1)) !important;
}

.data-\[active\=true\]\:\!bg-blue-500[data-active="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1)) !important;
}

.data-\[active\=true\]\:\!bg-purple-500[data-active="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1)) !important;
}

.data-\[active\=true\]\:\!bg-yellow-500[data-active="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1)) !important;
}

.data-\[active\=true\]\:bg-background-100[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-100)/var(--tw-bg-opacity, 1));
}

.data-\[active\=true\]\:bg-button-advisor-surface-pressed[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-advisor-surface-pressed)/var(--tw-bg-opacity, 1));
}

.data-\[active\=true\]\:bg-button-highlighted-surface-pressed[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-highlighted-surface-pressed)/var(--tw-bg-opacity, 1));
}

.data-\[active\=true\]\:bg-button-lined-surface-pressed[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-lined-surface-pressed)/var(--tw-bg-opacity, 1));
}

.data-\[active\=true\]\:bg-button-primary-surface-pressed[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-primary-surface-pressed)/var(--tw-bg-opacity, 1));
}

.data-\[active\=true\]\:bg-button-secondary-surface-pressed[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-secondary-surface-pressed)/var(--tw-bg-opacity, 1));
}

.data-\[active\=true\]\:bg-error-700[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-error-700)/var(--tw-bg-opacity, 1));
}

.data-\[active\=true\]\:bg-primary-600[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary-600)/var(--tw-bg-opacity, 1));
}

.data-\[active\=true\]\:bg-primary-700[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary-700)/var(--tw-bg-opacity, 1));
}

.data-\[active\=true\]\:bg-secondary-700[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-secondary-700)/var(--tw-bg-opacity, 1));
}

.data-\[active\=true\]\:bg-success-700[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success-700)/var(--tw-bg-opacity, 1));
}

.data-\[active\=true\]\:bg-transparent[data-active="true"] {
  background-color: rgba(0,0,0,0);
}

.data-\[active\=true\]\:data-\[checked\=true\]\:bg-primary-800[data-checked="true"][data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary-800)/var(--tw-bg-opacity, 1));
}

.data-\[checked\=true\]\:bg-background-100[data-checked="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-100)/var(--tw-bg-opacity, 1));
}

.data-\[checked\=true\]\:bg-primary-600[data-checked="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary-600)/var(--tw-bg-opacity, 1));
}

.data-\[checked\=true\]\:bg-transparent[data-checked="true"] {
  background-color: rgba(0,0,0,0);
}

.data-\[disabled\=true\]\:bg-background-50[data-disabled="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-50)/var(--tw-bg-opacity, 1));
}

.data-\[disabled\=true\]\:bg-primary-500[data-disabled="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary-500)/var(--tw-bg-opacity, 1));
}

.data-\[disabled\=true\]\:data-\[checked\=true\]\:bg-transparent[data-checked="true"][data-disabled="true"] {
  background-color: rgba(0,0,0,0);
}

.data-\[disabled\=true\]\:data-\[focus\=true\]\:bg-transparent[data-focus="true"][data-disabled="true"] {
  background-color: rgba(0,0,0,0);
}

.data-\[focus-visible\=true\]\:bg-background-100[data-focus-visible="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-100)/var(--tw-bg-opacity, 1));
}

.data-\[focus-visible\=true\]\:bg-background-50[data-focus-visible="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-50)/var(--tw-bg-opacity, 1));
}

.data-\[focus\=true\]\:\!bg-background-tertiary[data-focus="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--color-background-tertiary)/var(--tw-bg-opacity, 1)) !important;
}

.data-\[focus\=true\]\:\!bg-blue-500[data-focus="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1)) !important;
}

.data-\[focus\=true\]\:\!bg-purple-500[data-focus="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1)) !important;
}

.data-\[focus\=true\]\:\!bg-yellow-500[data-focus="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1)) !important;
}

.data-\[focus\=true\]\:bg-background-100[data-focus="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-100)/var(--tw-bg-opacity, 1));
}

.data-\[focus\=true\]\:bg-background-50[data-focus="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-50)/var(--tw-bg-opacity, 1));
}

.data-\[focus\=true\]\:bg-primary-600[data-focus="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary-600)/var(--tw-bg-opacity, 1));
}

.data-\[hover\=true\]\:\!bg-blue-500[data-hover="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1)) !important;
}

.data-\[hover\=true\]\:\!bg-purple-500[data-hover="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1)) !important;
}

.data-\[hover\=true\]\:\!bg-yellow-500[data-hover="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1)) !important;
}

.data-\[hover\=true\]\:bg-background-50[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-50)/var(--tw-bg-opacity, 1));
}

.data-\[hover\=true\]\:bg-background-tertiary[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-tertiary)/var(--tw-bg-opacity, 1));
}

.data-\[hover\=true\]\:bg-button-advisor-surface-hover[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-advisor-surface-hover)/var(--tw-bg-opacity, 1));
}

.data-\[hover\=true\]\:bg-button-highlighted-surface-hover[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-highlighted-surface-hover)/var(--tw-bg-opacity, 1));
}

.data-\[hover\=true\]\:bg-button-lined-surface-hover[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-lined-surface-hover)/var(--tw-bg-opacity, 1));
}

.data-\[hover\=true\]\:bg-button-primary-surface-hover[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-primary-surface-hover)/var(--tw-bg-opacity, 1));
}

.data-\[hover\=true\]\:bg-button-secondary-surface-hover[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-button-secondary-surface-hover)/var(--tw-bg-opacity, 1));
}

.data-\[hover\=true\]\:bg-error-600[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-error-600)/var(--tw-bg-opacity, 1));
}

.data-\[hover\=true\]\:bg-primary-600[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary-600)/var(--tw-bg-opacity, 1));
}

.data-\[hover\=true\]\:bg-secondary-600[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-secondary-600)/var(--tw-bg-opacity, 1));
}

.data-\[hover\=true\]\:bg-success-600[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success-600)/var(--tw-bg-opacity, 1));
}

.data-\[hover\=true\]\:bg-transparent[data-hover="true"] {
  background-color: rgba(0,0,0,0);
}

.data-\[hover\=true\]\:bg-zinc-200[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / var(--tw-bg-opacity, 1));
}

.data-\[hover\=true\]\:bg-zinc-50[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}

.data-\[hover\=true\]\:data-\[checked\=true\]\:bg-primary-700[data-checked="true"][data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary-700)/var(--tw-bg-opacity, 1));
}

.data-\[hover\=true\]\:data-\[checked\=true\]\:bg-transparent[data-checked="true"][data-hover="true"] {
  background-color: rgba(0,0,0,0);
}

.data-\[hover\=true\]\:data-\[checked\=true\]\:data-\[disabled\=true\]\:bg-primary-600[data-disabled="true"][data-checked="true"][data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary-600)/var(--tw-bg-opacity, 1));
}

.data-\[active\=true\]\:data-\[checked\=true\]\:text-typography-900[data-checked="true"][data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-900)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-button-advisor-icon-pressed[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-advisor-icon-pressed)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-button-advisor-label-pressed[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-advisor-label-pressed)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-button-highlighted-label-pressed[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-highlighted-label-pressed)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-button-lined-label-pressed[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-lined-label-pressed)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-button-primary-label-pressed[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-primary-label-pressed)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-button-secondary-label-pressed[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-secondary-label-pressed)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-button-text-label-pressed[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-text-label-pressed)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-error-700[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-error-700)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-foreground-primary[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-foreground-primary)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-foreground-secondary[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-foreground-secondary)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-info-700[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-info-700)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-primary-500[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary-500)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-primary-700[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary-700)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-success-700[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-success-700)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-typography-0[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-0)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-typography-700[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-700)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-typography-800[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-800)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:text-typography-900[data-active="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-900)/var(--tw-text-opacity, 1));
}

.data-\[checked\=true\]\:text-typography-900[data-checked="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-900)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:data-\[checked\=true\]\:data-\[disabled\=true\]\:text-typography-900[data-disabled="true"][data-checked="true"][data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-900)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:data-\[checked\=true\]\:text-typography-900[data-checked="true"][data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-900)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:data-\[disabled\=true\]\:data-\[checked\=true\]\:text-typography-900[data-checked="true"][data-disabled="true"][data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-900)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:data-\[disabled\=true\]\:text-typography-400[data-disabled="true"][data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-400)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:data-\[disabled\=true\]\:text-typography-600[data-disabled="true"][data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-600)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:text-button-advisor-icon-hover[data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-advisor-icon-hover)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:text-button-advisor-label-hover[data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-advisor-label-hover)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:text-button-highlighted-label-hover[data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-highlighted-label-hover)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:text-button-lined-label-hover[data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-lined-label-hover)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:text-button-primary-label-hover[data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-primary-label-hover)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:text-button-secondary-label-hover[data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-secondary-label-hover)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:text-button-text-label-hover[data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-button-text-label-hover)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:text-error-600[data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-error-600)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:text-foreground-primary[data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-foreground-primary)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:text-info-600[data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-info-600)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:text-primary-500[data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary-500)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:text-primary-600[data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary-600)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:text-success-600[data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-success-600)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:text-typography-0[data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-0)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:text-typography-600[data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-600)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:text-typography-800[data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-800)/var(--tw-text-opacity, 1));
}

.data-\[hover\=true\]\:text-typography-900[data-hover="true"] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-typography-900)/var(--tw-text-opacity, 1));
}

.data-\[active\=true\]\:underline[data-active="true"] {
  text-decoration-line: underline;
}

.data-\[hover\=true\]\:underline[data-hover="true"] {
  text-decoration-line: underline;
}

.data-\[hover\=true\]\:no-underline[data-hover="true"] {
  text-decoration-line: none;
}

.data-\[disabled\=true\]\:opacity-40[data-disabled="true"] {
  opacity: 0.4;
}

.data-\[disabled\=true\]\:opacity-50[data-disabled="true"] {
  opacity: 0.5;
}

.data-\[hover\=true\]\:data-\[checked\=true\]\:data-\[disabled\=true\]\:opacity-40[data-disabled="true"][data-checked="true"][data-hover="true"] {
  opacity: 0.4;
}

.data-\[hover\=true\]\:data-\[disabled\=true\]\:opacity-40[data-disabled="true"][data-hover="true"] {
  opacity: 0.4;
}

.data-\[focus-visible\=true\]\:outline-none[data-focus-visible="true"] {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.data-\[focus\=true\]\:outline-0[data-focus="true"] {
  outline-width: 0px;
}

.data-\[focus-visible\=true\]\:ring-2[data-focus-visible="true"] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.data-\[focus\=true\]\:ring-2[data-focus="true"] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.data-\[focus-visible\=true\]\:ring-indicator-info[data-focus-visible="true"] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--color-indicator-info)/var(--tw-ring-opacity, 1));
}

.data-\[focus\=true\]\:ring-indicator-primary[data-focus="true"] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--color-indicator-primary)/var(--tw-ring-opacity, 1));
}

.data-\[invalid\=true\]\:hover\:border-0:hover[data-invalid="true"] {
  border-width: 0px;
}

.data-\[disabled\=true\]\:hover\:border-background-300:hover[data-disabled="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-background-300)/var(--tw-border-opacity, 1));
}

.data-\[focus\=true\]\:hover\:border-primary-700:hover[data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary-700)/var(--tw-border-opacity, 1));
}

.data-\[invalid\=true\]\:data-\[disabled\=true\]\:hover\:border-error-700:hover[data-disabled="true"][data-invalid="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error-700)/var(--tw-border-opacity, 1));
}

.data-\[invalid\=true\]\:data-\[focus\=true\]\:hover\:border-error-700:hover[data-focus="true"][data-invalid="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error-700)/var(--tw-border-opacity, 1));
}

.data-\[invalid\=true\]\:hover\:border-error-700:hover[data-invalid="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error-700)/var(--tw-border-opacity, 1));
}

.web\:pointer-events-none {
  pointer-events: none;
}

.web\:pointer-events-auto {
  pointer-events: auto;
}

.web\:my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.web\:box-border {
  box-sizing: border-box;
}

.web\:w-full {
  width: 100%;
}

.web\:cursor-default {
  cursor: default;
}

.web\:cursor-pointer {
  cursor: pointer;
}

.web\:cursor-text {
  cursor: text;
}

.web\:select-none {
  -webkit-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.web\:list-none {
  list-style-type: none;
}

.web\:truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.web\:whitespace-nowrap {
  white-space: nowrap;
}

.web\:whitespace-pre-wrap {
  white-space: pre-wrap;
}

.web\:border-0 {
  border-width: 0px;
}

.web\:bg-transparent {
  background-color: rgba(0,0,0,0);
}

.web\:text-start {
  text-align: start;
}

.web\:font-sans {
  font-family: BricolageGrotesque, sans-serif;
}

.web\:outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.web\:outline-0 {
  outline-width: 0px;
}

.web\:backdrop-blur-sm {
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.web\:selection\:text-transparent *::selection {
  color: rgba(0,0,0,0);
}

.web\:selection\:text-transparent::selection {
  color: rgba(0,0,0,0);
}

.web\:focus\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.web\:focus-visible\:bg-background-100:focus-visible {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-100)/var(--tw-bg-opacity, 1));
}

.web\:disabled\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.data-\[disabled\=true\]\:web\:pointer-events-none[data-disabled="true"] {
  pointer-events: none;
}

.data-\[disabled\=true\]\:web\:pointer-events-auto[data-disabled="true"] {
  pointer-events: auto;
}

.data-\[disabled\=true\]\:web\:cursor-not-allowed[data-disabled="true"] {
  cursor: not-allowed;
}

.data-\[focus-visible\=true\]\:web\:cursor-pointer[data-focus-visible="true"] {
  cursor: pointer;
}

.web\:data-\[disabled\=true\]\:cursor-not-allowed[data-disabled="true"] {
  cursor: not-allowed;
}

.data-\[focus-visible\=true\]\:web\:bg-background-100[data-focus-visible="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-100)/var(--tw-bg-opacity, 1));
}

.web\:data-\[focus-visible\=true\]\:bg-background-100[data-focus-visible="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background-100)/var(--tw-bg-opacity, 1));
}

.data-\[focus-visible\=true\]\:web\:shadow-none[data-focus-visible="true"] {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\[focus\=true\]\:web\:shadow-\[inset_0_-1px_0_0\][data-focus="true"] {
  --tw-shadow: inset 0 -1px 0 0;
  --tw-shadow-colored: inset 0 -1px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\[focus\=true\]\:web\:shadow-\[inset_0_0_0_1px\][data-focus="true"] {
  --tw-shadow: inset 0 0 0 1px;
  --tw-shadow-colored: inset 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\[focus\=true\]\:web\:shadow-none[data-focus="true"] {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\[invalid\=true\]\:web\:shadow-\[inset_0_0_0_1px\][data-invalid="true"] {
  --tw-shadow: inset 0 0 0 1px;
  --tw-shadow-colored: inset 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\[invalid\=true\]\:web\:shadow-none[data-invalid="true"] {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\[focus\=true\]\:data-\[hover\=true\]\:web\:shadow-primary-600[data-hover="true"][data-focus="true"] {
  --tw-shadow-color: rgb(var(--color-primary-600)/1);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\[focus\=true\]\:web\:shadow-primary-700[data-focus="true"] {
  --tw-shadow-color: rgb(var(--color-primary-700)/1);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\[invalid\=true\]\:web\:shadow-error-700[data-invalid="true"] {
  --tw-shadow-color: rgb(var(--color-error-700)/1);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\[focus-visible\=true\]\:web\:outline-none[data-focus-visible="true"] {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.data-\[focus\=true\]\:web\:outline-none[data-focus="true"] {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.web\:data-\[focus-visible\=true\]\:outline-none[data-focus-visible="true"] {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.data-\[focus-visible\=true\]\:web\:outline[data-focus-visible="true"] {
  outline-style: solid;
}

.web\:data-\[active\=true\]\:outline[data-active="true"] {
  outline-style: solid;
}

.web\:data-\[focus\=true\]\:outline[data-focus="true"] {
  outline-style: solid;
}

.data-\[focus-visible\=true\]\:web\:outline-0[data-focus-visible="true"] {
  outline-width: 0px;
}

.data-\[focus-visible\=true\]\:web\:outline-2[data-focus-visible="true"] {
  outline-width: 2px;
}

.data-\[focus\=true\]\:web\:outline-0[data-focus="true"] {
  outline-width: 0px;
}

.web\:data-\[active\=true\]\:\!outline-1[data-active="true"] {
  outline-width: 1px !important;
}

.web\:data-\[active\=true\]\:outline-4[data-active="true"] {
  outline-width: 4px;
}

.web\:data-\[focus\=true\]\:\!outline-1[data-focus="true"] {
  outline-width: 1px !important;
}

.data-\[focus-visible\=true\]\:web\:outline-primary-700[data-focus-visible="true"] {
  outline-color: rgb(var(--color-primary-700)/1);
}

.web\:data-\[active\=true\]\:outline-blue-400[data-active="true"] {
  outline-color: #60a5fa;
}

.web\:data-\[active\=true\]\:outline-primary-400[data-active="true"] {
  outline-color: rgb(var(--color-primary-400)/1);
}

.web\:data-\[active\=true\]\:outline-purple-400[data-active="true"] {
  outline-color: #c084fc;
}

.web\:data-\[active\=true\]\:outline-yellow-400[data-active="true"] {
  outline-color: #facc15;
}

.web\:data-\[focus-visible\=true\]\:outline-indicator-primary[data-focus-visible="true"] {
  outline-color: rgb(var(--color-indicator-primary)/1);
}

.web\:data-\[focus\=true\]\:outline-blue-400[data-focus="true"] {
  outline-color: #60a5fa;
}

.web\:data-\[focus\=true\]\:outline-purple-400[data-focus="true"] {
  outline-color: #c084fc;
}

.web\:data-\[focus\=true\]\:outline-yellow-400[data-focus="true"] {
  outline-color: #facc15;
}

.data-\[focus-visible\=true\]\:web\:ring-2[data-focus-visible="true"] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.data-\[focus\=true\]\:web\:ring-0[data-focus="true"] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.data-\[focus\=true\]\:web\:ring-1[data-focus="true"] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.data-\[invalid\=true\]\:data-\[disabled\=true\]\:data-\[hover\=true\]\:web\:ring-1[data-hover="true"][data-disabled="true"][data-invalid="true"] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.data-\[invalid\=true\]\:data-\[focus\=true\]\:data-\[hover\=true\]\:web\:ring-1[data-hover="true"][data-focus="true"][data-invalid="true"] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.data-\[invalid\=true\]\:data-\[focus\=true\]\:web\:ring-0[data-focus="true"][data-invalid="true"] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.data-\[invalid\=true\]\:web\:ring-0[data-invalid="true"] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.data-\[invalid\=true\]\:web\:ring-1[data-invalid="true"] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.web\:data-\[focus-visible\=true\]\:ring-2[data-focus-visible="true"] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.data-\[focus\=true\]\:web\:ring-inset[data-focus="true"] {
  --tw-ring-inset: inset;
}

.data-\[invalid\=true\]\:data-\[disabled\=true\]\:data-\[hover\=true\]\:web\:ring-inset[data-hover="true"][data-disabled="true"][data-invalid="true"] {
  --tw-ring-inset: inset;
}

.data-\[invalid\=true\]\:data-\[focus\=true\]\:data-\[hover\=true\]\:web\:ring-inset[data-hover="true"][data-focus="true"][data-invalid="true"] {
  --tw-ring-inset: inset;
}

.data-\[invalid\=true\]\:web\:ring-inset[data-invalid="true"] {
  --tw-ring-inset: inset;
}

.data-\[focus-visible\=true\]\:web\:ring-indicator-info[data-focus-visible="true"] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--color-indicator-info)/var(--tw-ring-opacity, 1));
}

.data-\[focus-visible\=true\]\:web\:ring-indicator-primary[data-focus-visible="true"] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--color-indicator-primary)/var(--tw-ring-opacity, 1));
}

.data-\[focus\=true\]\:web\:ring-indicator-primary[data-focus="true"] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--color-indicator-primary)/var(--tw-ring-opacity, 1));
}

.data-\[invalid\=true\]\:data-\[disabled\=true\]\:data-\[hover\=true\]\:web\:ring-indicator-error[data-hover="true"][data-disabled="true"][data-invalid="true"] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--color-indicator-error)/var(--tw-ring-opacity, 1));
}

.data-\[invalid\=true\]\:data-\[focus\=true\]\:data-\[hover\=true\]\:web\:ring-indicator-primary[data-hover="true"][data-focus="true"][data-invalid="true"] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--color-indicator-primary)/var(--tw-ring-opacity, 1));
}

.data-\[invalid\=true\]\:web\:ring-indicator-error[data-invalid="true"] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--color-indicator-error)/var(--tw-ring-opacity, 1));
}

.web\:data-\[focus-visible\=true\]\:ring-indicator-primary[data-focus-visible="true"] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--color-indicator-primary)/var(--tw-ring-opacity, 1));
}

.data-\[invalid\=true\]\:data-\[disabled\=true\]\:hover\:web\:ring-1:hover[data-disabled="true"][data-invalid="true"] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.data-\[invalid\=true\]\:data-\[focus\=true\]\:hover\:web\:ring-1:hover[data-focus="true"][data-invalid="true"] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.data-\[invalid\=true\]\:data-\[disabled\=true\]\:hover\:web\:ring-inset:hover[data-disabled="true"][data-invalid="true"] {
  --tw-ring-inset: inset;
}

.data-\[invalid\=true\]\:data-\[focus\=true\]\:hover\:web\:ring-inset:hover[data-focus="true"][data-invalid="true"] {
  --tw-ring-inset: inset;
}

.data-\[invalid\=true\]\:data-\[disabled\=true\]\:hover\:web\:ring-indicator-error:hover[data-disabled="true"][data-invalid="true"] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--color-indicator-error)/var(--tw-ring-opacity, 1));
}

.data-\[invalid\=true\]\:data-\[focus\=true\]\:hover\:web\:ring-indicator-error:hover[data-focus="true"][data-invalid="true"] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--color-indicator-error)/var(--tw-ring-opacity, 1));
}

@media not all and (min-width: 640px) {
  .max-sm\:flex {
    display: flex;
  }

  .max-sm\:hidden {
    display: none;
  }
}

@media (max-width: 500px) {
  .max-\[500px\]\:gap-10 {
    gap: 20px;
  }
}

@media (min-width: 640px) {
  .sm\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
